// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.breadcrumb :hover {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./../../libraries/components/dist/src/Breadcrumbs/Breadcrumbs.scss"],"names":[],"mappings":"AACI;EACI,eAAA;AAAR","sourcesContent":[".breadcrumb {\n    :hover {\n        cursor: pointer;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
